import React, { useState } from "react";
import { Button } from "@material-ui/core";
import DataTable from "@/components/DataTable";
import { ReactRender } from "@/components/ReactRender";
import { useTranslation } from "@/langs/useTranslation";
import ScheduleTaskType from "@/containers/Schedule/CreateTemplate/TaskCreator/TaskType";
import Autocomplete from "@/components/Autocomplete";

const DeviceSerialNumberSelector = ({ getDevices, name, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <Autocomplete
      placeholder={t({ defaultMessage: "输入设备SN" })}
      options={getDevices()
        .filter(item => item.os_type === "windows")
        .map(item => ({
          id: item.id,
          name: item.serial_number
        }))}
      name={name}
      value={value}
      onChange={onChange}
      style={{ width: 300 }}
    />
  );
};

export const SelectedScheduleTemplateDatatable = React.forwardRef(
  (
    {
      className,
      style,
      data,
      children,
      onLoaded,
      onDelete,
      setDeviceData,
      getDevices
    },
    ref
  ) => {
    const { t } = useTranslation();

    const columns = [
      {
        name: "schedule_template_name",
        data: "schedule_template_name",
        title: t({ defaultMessage: "排程模板名称" }),
        searchable: true
      },
      {
        data: "task_type",
        title: t({ defaultMessage: "排程任务" }),
        createdCell: (td, data, row) => {
          ReactRender(<ScheduleTaskType data={row} />, td);
        }
      },
      {
        data: null,
        width: 320,
        title: t({ defaultMessage: "开机设备" }),
        createdCell: (td, data, row, rowIndex) => {
          ReactRender(
            row.task_type === "start" ? (
              <DeviceSerialNumberSelector
                getDevices={getDevices}
                value={row.deviceData}
                onChange={e => setDeviceData(e.target.value, rowIndex)}
              />
            ) : null,
            td
          );
        }
      },
      {
        name: "schedule_template_name",
        data: "schedule_template_name",
        width: 120,
        title: t({ defaultMessage: "操作" }),
        className: "center",
        createdCell: (td, data, row) => {
          ReactRender(
            <Button
              size="small"
              color="secondary"
              onClick={() => onDelete(row)}
            >
              {t({ defaultMessage: "删除" })}
            </Button>,
            td
          );
        }
      }
    ];

    return (
      <DataTable
        ref={ref}
        options={{ serverSide: false, paging: false }}
        rowsGroup={["schedule_template_name:name"]}
        columns={columns}
        data={data}
        className={className}
        style={style}
        autoLoad
        showFooter={false}
        onLoaded={onLoaded}
      >
        {children}
      </DataTable>
    );
  }
);
